<template>
  <div class="solfigrplyr solfigrplyr_add">
    <div class="solfigrplyr_left">
      <div class="d-flex position-relative">
        <div class="mdi mdi-account-plus solfigrplyr_add_icon"></div>
        <div class="d-flex flex-column my-auto pl-3 ga-1">
          <div class="solfigrplyr_name">{{ $t('common.add_player') }}</div>
          <div class="solfigrplyr_badge">{{ $t('common.coming_soon') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.solfigrplyr {
  min-height: 0;
  min-width: 15rem;
  display: flex;
  gap: 0.5rem;
  background: var(--palette-action-disabledBackground);
  padding: 0.5rem;
  gap: 1rem;
  border-radius: 4px;

  &_add {
    opacity: 0.85;

    &_icon {
      width: 5.2rem;
      height: 5.2rem;
      background: var(--clr-black-0);
      opacity: 0.3;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      font-size: 2.5rem;
    }
  }

  &_left {
    display: flex;
    flex-direction: column;
    min-width: 7rem;
  }

  &_name {
    font-size: 1rem;
    font-weight: 700;
    opacity: 0.6;
  }

  &_badge {
    font-size: 10px;
    font-weight: 700;
    color: var(--palette-warning-main);
    border: 2px solid var(--palette-warning-main);
    border-radius: 100px;
    display: inline-block;
    text-align: center;
    margin: 0 auto;
    display: flex;
    gap: 4px;
    padding: 2px 6px;
    text-transform: uppercase;
  }
}
</style>
